import { FC } from 'react'
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/Alert/AlertDialog'
import { AlertDialog, AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useDeleteBuilding } from '../lib/use-delete-building'
import { Loader } from '@mantine/core'
import { useTranslation } from 'react-i18next'

type DeleteBuildingAlertProps = {
  selectBuildingId: number
  onClose: () => void
}

export const DeleteBuildingAlert: FC<DeleteBuildingAlertProps & AlertDialogProps> = ({
  selectBuildingId,
  onClose,
  ...props
}) => {
  const { isLoadingDelete, handleDeleteBuilding } = useDeleteBuilding()
  const { t } = useTranslation(['building'])

  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('building:confirmation.are_you_absolutely_sure')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('building:confirmation.action_cannot_be_undone')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoadingDelete}>
            {t('building:buttons.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isLoadingDelete}
            className='bg-red hover:bg-red/80'
            onClick={() => handleDeleteBuilding(selectBuildingId, onClose)}
          >
            {isLoadingDelete ? <Loader color='white' size='xs' /> : t('building:buttons.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
